import React from 'react';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import css from './CommunityPage.module.css';

const CommunityPage = () => {

  return (
    <div className={css.root}>
      <div className={css.iframeContainer}>
        <TopbarContainer
        />
        <iframe 
          src="https://joodaic.bettermode.io?layout=default"
          className={css.iframe}
          allowFullScreen
        />
      </div>
      
    </div>
  );
};


export default CommunityPage; 